
import Mandatetype from "../../../component/systemMaster/mandateType/mandateType"

const Mandate = () => {

    return <Mandatetype/>
};

export default Mandate;
